var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { small: _vm.className === "small" } },
    [
      _c(
        "vue-ladda",
        {
          attrs: {
            "button-class": "btn btn-success btn-xs phoneCall_btn",
            "data-style": "zoom-in",
            loading: _vm.phoneCallLoading,
          },
          on: {
            click: function ($event) {
              return _vm.makePhoneCall()
            },
          },
        },
        [_c("i", { staticClass: "icon-fa icon-fa-phone-square" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }